export const teresinaCenter = {
    lat: -5.1117973573655995,
    lng: -42.80055871587112,
};
